import { MinusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Space, TimePicker } from 'antd';
import React from 'react';

import type { FormValues } from '../../types';
import { timeRangeValidator } from './helpers';

const TimeRangePicker = TimePicker.RangePicker;

type TimeRangeListFieldProps = {
  slot: FormValues['slot'];
};

const TimeRangeListField = ({ slot }: TimeRangeListFieldProps) => {
  return (
    <Form.Item label="時間段" required>
      <Form.List name="slot">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => {
              return (
                <Space key={field.key} align="baseline">
                  <Form.Item
                    {...field}
                    name={field.name}
                    rules={[
                      {
                        type: 'array',
                        validateTrigger: 'onSubmit',
                        validator: async (_, value) =>
                          await timeRangeValidator({
                            timeRange: value,
                            timeRanges: slot,
                            index: field.name,
                          }),
                      },
                    ]}
                  >
                    <TimeRangePicker
                      format="HH:mm"
                      placeholder={['開始時間', '結束時間']}
                    />
                  </Form.Item>
                  {fields.length > 1 ? (
                    <MinusCircleFilled
                      rev={undefined}
                      onClick={() => remove(field.name)}
                    />
                  ) : null}
                </Space>
              );
            })}
            <Form.Item>
              <Button
                onClick={() => add()}
                icon={<PlusOutlined rev={undefined} />}
              >
                新增時間段
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
};

export default TimeRangeListField;
